import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { Overlay } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ComponentPortal } from '@angular/cdk/portal';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { EndPointApi } from '@helpers/endpointapi';
import { VesselSelectListComponent } from '@components/vessel-select-list/vessel-select-list.component';
import { TableLoadingComponent } from '@components/table-loading/table-loading.component';
import { AzureLoginPromptComponent } from '@components/azure-login-prompt/azure-login-prompt.component';

@Injectable({ providedIn: 'root' })
export class VesselSelectService {
    overlayRef = this.overlay.create({
        hasBackdrop: true,
        positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
    });

    vesselData: any;

    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(
        public dialog: MatDialog,
        private overlay: Overlay,
        private toastr: ToastrService,
        private translateService: TranslateService,
        private http: HttpClient,
    ) {
        this.domain = EndPointApi.iApiDomain();
    }

    async openVesselSelectDialog(builderId: string, builderName: string) {
        if (!this.overlayRef.hasAttached()) {
            this.overlayRef.attach(new ComponentPortal(TableLoadingComponent));
        }
        try {
            const vesselList = await this.getVesselList(builderName);
            this.overlayRef.detach();
            if (vesselList.length == 0) {
                return;
            }
            vesselList.sort(this.compareForSort);
            vesselList.push({ builder_id: builderId, name: builderName });
            const dialogRef = this.dialog.open(VesselSelectListComponent, {
                data: vesselList,
            });

            const result = await lastValueFrom(dialogRef.afterClosed());
            return result;
        } catch (e) {
            if (e.status === HttpStatusCode.Forbidden) {
                this.overlayRef.detach();
                this.dialog.open(AzureLoginPromptComponent);
            } else {
                this.notifyError(e);
                this.overlayRef.detach();
                return;
            }
        }
    }

    private getVesselList(builderName: string): Promise<any> {
        const param = {
            vesselBuilder: builderName,
        };

        return lastValueFrom(
            this.http.get(`${this.domain}/api/vesseliAPi`, {
                headers: this.headers,
                params: param,
            }),
        );
    }

    private compareForSort(vessel1: any, vessel2: any) {
        let r = 0;
        if (vessel1.name < vessel2.name) {
            r = -1;
        } else if (vessel1.name > vessel2.name) {
            r = 1;
        }

        return r;
    }

    public notifyError(error) {
        console.error(error);

        this.toastr.error(error?.message, '', {
            timeOut: 3000,
            closeButton: true,
            disableTimeOut: true,
        });
    }
}
